import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'sn-pagination',
	template: require('./sn-pagination.html'),
	styles: [require('./sn-pagination.scss')]
})
export class SnPaginationComponent implements OnInit {
	@Input() pageRequest: PageRequest;
	@Input() totalItems: number;
	@Input() pageNumbers: Array<number>;
	@Output() renew: EventEmitter<any> = new EventEmitter<any>();

	constructor(private paginationService: PaginationService) {}

	ngOnInit() {}

	getCurrentPage(): number {
		return this.pageRequest.paging.pageNumber;
	}

	goToPage(newPage: number, disabled: boolean): void {
		if (!disabled) {
			this.getNewPageRequest(newPage);
		}
	}

	jumpBack(disabled: boolean): void {
		if (!disabled) {
			if (this.pageRequest.paging.pageNumber > 0) {
				this.getNewPageRequest(this.pageRequest.paging.pageNumber - 1);
			}
		}
	}

	jumpAhead(disabled: boolean): void {
		if (!disabled) {
			if (
				this.totalItems >=
				this.pageRequest.paging.pageNumber * this.pageRequest.paging.pageSize +
					1
			) {
				this.getNewPageRequest(this.pageRequest.paging.pageNumber + 1);
			}
		}
	}

	perPageChanged(newPerPage: number): void {
		this.getNewPageRequest(null, newPerPage);
	}

	private getNewPageRequest(pageNumber: number, perPage?: number): void {
		const newPageRequest = this.paginationService.getResultsPage(
			this.pageRequest,
			this.totalItems,
			pageNumber,
			perPage
		);
		if (newPageRequest) {
			this.renew.emit(newPageRequest);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/sn-pagination/sn-pagination.ts